import { Component } from 'react';
import { connect } from 'react-redux';
import { memoizeLast } from '../utils/functionUtils';
import { push } from '../actions/HistoryActions';
import TranslateTemplateModal from '../components/translationModal/template/TranslateTemplateModal';
import { getCustomizeTemplatePath } from '../routing/utils/internalPaths';
import { jsx as _jsx } from "react/jsx-runtime";
class TranslateTemplateModalContainer extends Component {
  constructor(...args) {
    super(...args);
    this.getAllLanguages = memoizeLast((primaryLanguage, additionalLanguages) => {
      return [primaryLanguage, ...additionalLanguages];
    });
    this.onClose = () => {
      this.props.routeChange(getCustomizeTemplatePath());
    };
  }
  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'primaryLanguage' does not exist on type ... Remove this comment to see the full error message
      primaryLanguage,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'additionalLanguages' does not exist on t... Remove this comment to see the full error message
      additionalLanguages,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'articleLanguage' does not exist on type ... Remove this comment to see the full error message
      articleLanguage
    } = this.props;
    const allLanguages = this.getAllLanguages(primaryLanguage, additionalLanguages);
    return /*#__PURE__*/_jsx(TranslateTemplateModal, {
      articleLanguage: articleLanguage,
      allLanguages: allLanguages,
      onClose: this.onClose
    });
  }
}
const mapStateToProps = state => {
  const {
    knowledgeBaseDetails: {
      knowledgeBase: {
        language: primaryLanguage,
        additionalLanguages
      }
    },
    templateEditorNavigationContext: {
      selectedLanguage
    }
  } = state;
  return {
    articleLanguage: selectedLanguage,
    primaryLanguage,
    additionalLanguages
  };
};
const mapDispatchToProps = {
  routeChange: push
};
export default connect(mapStateToProps, mapDispatchToProps)(TranslateTemplateModalContainer);